import CriarCargo from "../views/atos-pessoal/CriarCargo.vue";
import ImportarXmlCargo from "../views/atos-pessoal/ImportarXmlCargo.vue";
import ConsultarCargo from "../views/atos-pessoal/ConsultarCargo.vue";
import DetalhesCargo from "../views/atos-pessoal/DetalhesCargo.vue";
import AlteracaoNormativa from "../views/atos-pessoal/AlteracaoNormativa.vue";
import CorrigirDados from "../views/atos-pessoal/CorrigirDados.vue";
import ModalAlteracaoCargo from "../components/atos-pessoal/ModalAlteracaoCargo.vue";
import Aposentadorias from "@/views/atos-pessoal/Aposentadorias.vue";
import FiltrarConcursos from "@/views/atos-pessoal/FiltrarConcursos.vue";
import FiltrarBancas from "@/views/atos-pessoal/banca/FiltrarBanca.vue";
import TiposAnexo from "@/views/atos-pessoal/tipos-anexo/TiposAnexo.vue";
import CriarConcurso from "@/views/atos-pessoal/CriarConcurso.vue";
import DetalhesEdital from "@/views/atos-pessoal/DetalhesEdital.vue";
import EditarEdital from "@/views/atos-pessoal/EditarEdital.vue";

const atosPessoalRotas = [
  {
    path: "/atos-pessoal/cargos/consulta",
    name: "ConsultaCargo",
    component: ConsultarCargo,
  },
  {
    path: "/atos-pessoal/cargos/criar",
    name: "CriarCargo",
    component: CriarCargo,
  },
  {
    path: "/atos-pessoal/cargos/importar-xml",
    name: "ImportarXmlCargo",
    component: ImportarXmlCargo,
  },
  {
    path: "/atos-pessoal/cargos/:idCargo/alteracao-normativa",
    name: "AlteracaoNormativa",
    component: AlteracaoNormativa,
    props: true,
  },
  {
    path: "/atos-pessoal/cargos/:idCargo/correcao-dados",
    name: "CorrigirDados",
    component: CorrigirDados,
    props: true,
  },
  {
    path: "/atos-pessoal/cargos/:idCargo",
    name: "DetalhesCargo",
    component: DetalhesCargo,
    props: true,
    children: [
      {
        path: "alteracao/:idAlteracao",
        name: "ModalAlteracaoCargo",
        component: ModalAlteracaoCargo,
        props: true,
      },
    ],
  },
  {
    path: "/atos-pessoal/aposentadorias",
    name: "aposentadorias",
    component: Aposentadorias,
    props: true,
  },
  {
    path: "/atos-pessoal/concursos",
    name: "concursos",
    component: FiltrarConcursos,
  },
  {
    path: "/atos-pessoal/bancas",
    name: "Bancas",
    component: FiltrarBancas,
  },
  {
    path: "/atos-pessoal/tipos-anexo",
    name: "TiposAnexo",
    component: TiposAnexo,
  },
  {
    path: "/atos-pessoal/concursos/criar-concurso",
    name: "CriarConcurso",
    component: CriarConcurso,
  },
  {
    path: "/atos-pessoal/concursos/detalhes-edital/:idEdital",
    name: "DetalhesEdital",
    component: DetalhesEdital,
    props: true,
  },
  {
    path: "/atos-pessoal/concursos/editar-edital/:idEdital/:pageTab",
    name: "EditarEdital",
    component: EditarEdital,
    props: true,
  },
];

export { atosPessoalRotas };
